import PathPage from '../hortmag.com/[[...path]].page';

export default PathPage;

export { getServerSideProps } from '../hortmag.com/[[...path]].page';
